import { render, staticRenderFns } from "./discountrecord.vue?vue&type=template&id=7f57223e&scoped=true&"
import script from "./discountrecord.vue?vue&type=script&lang=js&"
export * from "./discountrecord.vue?vue&type=script&lang=js&"
import style0 from "./discountrecord.vue?vue&type=style&index=0&id=7f57223e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f57223e",
  null
  
)

export default component.exports